export const getDeviceType = (width): string => {
  if (width > 1024) {
    return 'desktop'
  } else if (width > 768) {
    return 'tablet'
  } else {
    return 'mobile'
  }
}
